import React from 'react';
import { HOME_URL } from '../../constants/products-constants';

const encode = (data) => {
  return Object.keys(data)
      .map(key => encodeURIComponent(key) + "=" + encodeURIComponent(data[key]))
      .join("&");
}

class SupportPageComponent extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      name: "",
      companyName: "",
      email: "",
      phone: "",
      application: "",
      endProduct: "",
      estimatedProductionDate: "",
      partNumber: "",
      packageType: "",
      quantity: "",
      shippingMethod: "",
      shippingAccountNumber: "",
      address: "",
      address2: "",
      country: "",
      state: "",
      zip: "",
      newOrExistingDesign: "",
      purchasingOrEngineering: "",
      howDidYouHearAboutUs: "",
      comments: ""
    };
  }

  handleSubmit = e => {
    e.preventDefault();
    const form = e.target;
    fetch(form.action, {
      method: form.method,
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: encode({ "form-name": "contact", ...this.state })
    })
      .then(() => alert("Success!"))
      .catch(error => alert(error));
    console.log('Form submission:', this.state);
  };

  handleChange = e => {
    this.setState({ [e.target.name]: e.target.value });
  }

  render() {
    const {
      name,
      companyName,
      email,
      phone,
      application,
      endProduct,
      estimatedProductionDate,
      partNumber,
      packageType,
      quantity,
      shippingMethod,
      shippingAccountNumber,
      address,
      address2,
      country,
      state,
      zip,
      newOrExistingDesign,
      purchasingOrEngineering,
      howDidYouHearAboutUs,
      comments
    } = this.state;

    return (
      <div className="container mt-5 card border-0">
        <div className="row">
          <div className="col-12 col-md-10 col-lg-5 order-lg-last g-5">
            <p className="lead">
              <img className="img-fluid w-100" src={`${HOME_URL}/images/Linear_0719_014s150.jpg`} alt="Linear Integrated Systems team" />
            </p>
            <h4>Linear Systems</h4>
            <address>
              <p>4042 Clipper Court<br/>Fremont, CA 94538</p>
              <hr/>
              <p>
                Email: sales@linearsystems.com
                <br />
                Phone number: +1 (510) 490-9160
                <br />
                Fax number: +1 (510) 353-0261
              </p>
            </address>
          </div>
  
          <hr className="my-5 d-lg-none"/>
  
          <div className="col-md-12 col-lg-7 g-5">
            <h4 className="mb-3">Fill out the form</h4>
            <p>Please complete this form and we will process your request.</p>
            <p>If you need further assistance please call 510-490-9160 or email sales@linearsystems.com</p>
  
            <hr className="my-5"/>
  
            <form name="linear-systems-support" action="https://formspree.io/f/xpznqgry" method="POST" onSubmit={this.handleSubmit} novalidate="">
            <div className="row g-3 align-items-end">
                <div className="col-sm-6">
                  <label for="name" className="form-label">Name</label>
                  <input type="text" className="form-control" id="name" placeholder="John Doe" required="" value={name} onChange={this.handleChange} name="name" />
                  <div className="invalid-feedback">
                    Valid name is required.
                  </div>
                </div>
  
                <div className="col-6">
                  <label for="companyName" className="form-label">Company name</label>
                  <input type="text" className="form-control" id="company-ame" placeholder="Your Company" value={companyName} onChange={this.handleChange} name="companyName" />
                  <div className="invalid-feedback">
                    Please enter a valid email address.
                  </div>
                </div>
  
                <div className="col-6">
                  <label for="email" className="form-label">Email</label>
                  <input type="email" className="form-control" id="email" placeholder="you@example.com" value={email} onChange={this.handleChange} name="email" />
                  <div className="invalid-feedback">
                    Please enter a valid email address.
                  </div>
                </div>
  
                <div className="col-6">
                  <label for="phone" className="form-label">Phone</label>
                  <input type="tel" className="form-control" id="phone" pattern="[0-9]{3}-[0-9]{3}-[0-9]{4}" placeholder="510-490-9160" required="" value={phone} onChange={this.handleChange} name="phone" />
                  <div className="invalid-feedback">
                    Please enter a valid phone number.
                  </div>
                </div>
              </div>
  
              <hr className="my-5"/>
  
              <div className="row g-3 align-items-end">
                <div className="col-sm-6">
                  <label for="name" className="form-label">Application</label>
                  <input type="text" className="form-control" id="application" placeholder="Application" required="" value={application} onChange={this.handleChange} name="application" />
                  <div className="invalid-feedback">
                    Valid application is required.
                  </div>
                </div>
  
                <div className="col-sm-6">
                  <label for="name" className="form-label">End product</label>
                  <input type="text" className="form-control" id="end-product" placeholder="End product" required="" value={endProduct} onChange={this.handleChange} name="endProduct" />
                  <div className="invalid-feedback">
                    Valid end product is required.
                  </div>
                </div>
  
                <div className="col-sm-6">
                  <label for="name" className="form-label">Estimated production date</label>
                  <input type="text" className="form-control" id="estimated-production-date" placeholder="1/1/2000" required="" value={estimatedProductionDate} onChange={this.handleChange} name="estimatedProductionDate" />
                  <div className="invalid-feedback">
                    Valid date is required.
                  </div>
                </div>
  
                <div className="col-sm-6">
                  <label for="name" className="form-label">Part number</label>
                  <input type="text" className="form-control" id="part-number" placeholder="Part number" required="" value={partNumber} onChange={this.handleChange} name="partNumber" />
                  <div className="invalid-feedback">
                    Valid part number is required.
                  </div>
                </div>
  
                <div className="col-sm-6">
                  <label for="name" className="form-label">Package type</label>
                  <input type="text" className="form-control" id="package-type" placeholder="Package type" required="" value={packageType} onChange={this.handleChange} name="packageType" />
                  <div className="invalid-feedback">
                    Valid package type is required.
                  </div>
                </div>
  
                <div className="col-sm-6">
                  <label for="name" className="form-label">Quantity</label>
                  <input type="text" className="form-control" id="quantity" placeholder="Quantity" required="" value={quantity} onChange={this.handleChange} name="quantity" />
                  <div className="invalid-feedback">
                    Valid quantity is required.
                  </div>
                </div>
              </div>
  
              <hr className="my-5"/>
  
              <div className="row g-3 align-items-end">
                <div className="col-sm-6">
                  <label for="name" className="form-label">Shipping method</label>
                  <input type="text" className="form-control" id="shipping-method" placeholder="Shipping method" required="" value={shippingMethod} onChange={this.handleChange} name="shippingMethod" />
                  <div className="invalid-feedback">
                    Valid shipping method is required.
                  </div>
                </div>
  
                <div className="col-sm-6">
                  <label for="name" className="form-label">Shipping account number</label>
                  <input type="text" className="form-control" id="shipping-account-number" placeholder="Shipping account number" required="" value={shippingAccountNumber} onChange={this.handleChange} name="shippingAccountNumber" />
                  <div className="invalid-feedback">
                    Valid shipping account number is required.
                  </div>
                </div>
  
                <div className="col-6">
                  <label for="address" className="form-label">Address</label>
                  <input type="text" className="form-control" id="address" placeholder="1234 Main St" required="" value={address} onChange={this.handleChange} name="address" />
                  <div className="invalid-feedback">
                    Please enter your address.
                  </div>
                </div>
  
                <div className="col-6">
                  <label for="address2" className="form-label">Address 2</label>
                  <input type="text" className="form-control" id="address-2" placeholder="Apartment or suite" value={address2} onChange={this.handleChange} name="address2" />
                </div>
  
                <div className="col-md-5">
                  <label for="country" className="form-label">Country</label>
                  <select className="form-select" id="country" value={country} onChange={this.handleChange}>name="country" 
                    <option value="">Choose...</option>
                    <option value="United States">United States</option>
                  </select>
                  <div className="invalid-feedback">
                    Please select a valid country.
                  </div>
                </div>
  
                <div className="col-md-4">
                  <label for="state" className="form-label">State</label>
                  <select className="form-select" id="state" value={state} onChange={this.handleChange} name="state" >
                    <option value="">Choose...</option>
                    <option value="California">California</option>
                  </select>
                  <div className="invalid-feedback">
                    Please provide a valid state.
                  </div>
                </div>
  
                <div className="col-md-3">
                  <label for="zip" className="form-label">Zip</label>
                  <input type="text" className="form-control" id="zip" placeholder="" value={zip} onChange={this.handleChange} name="zip" />
                  <div className="invalid-feedback">
                    Zip code required.
                  </div>
                </div>
              </div>
  
              <hr className="my-5"/>
  
              <div className="row g-3 align-items-end">
                <div className="col-sm-4">
                  <label for="name" className="form-label">Is this for a New or Existing design?</label>
                  <input type="text" className="form-control" id="is-this-for-a-new-or-existing-esign" placeholder="Existing design" value={newOrExistingDesign} onChange={this.handleChange} name="newOrExistingDesign" />
                  <div className="invalid-feedback">
                    Valid option is required.
                  </div>
                </div>
  
                <div className="col-sm-4">
                  <label for="name" className="form-label">Are you in Purchasing or Engineering?</label>
                  <input type="text" className="form-control" id="are-you-in-purchasing-or-engineering" placeholder="Purchasing" value={purchasingOrEngineering} onChange={this.handleChange} name="purchasingOrEngineering" />
                  <div className="invalid-feedback">
                    Valid option is required.
                  </div>
                </div>
  
                <div className="col-sm-4">
                <label for="how-did-you-hear-about-us" className="form-label">How did you hear about us?</label>
                  <select className="form-select" id="how-did-you-hear-about-us" value={howDidYouHearAboutUs} onChange={this.handleChange} name="howDidYouHearAboutUs">
                    <option value="">Internet search</option>
                    <option value="">Print ad</option>
                    <option value="">Word-of-mouth</option>
                    <option value="">Current customer</option>
                    <option value="">Other</option>
                  </select>
                </div>
  
                <div className="col-sm-12">
                  <label for="comments" className="form-label">Comments</label>
                  <textarea className="form-control" id="additional-comments" placeholder="Any additional comments." value={comments} onChange={this.handleChange}>name="comments" </textarea>
                </div>
              </div>
  
              <hr className="my-5"/>
  
              <div className="row g-3 mb-5">
                <div className="col-sm-12">
                  <button className="w-100 btn btn-primary" type="submit">Submit</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

export default SupportPageComponent;